/* Gold & Richie — quick view
   Opens a compact product view without leaving the grid.
   The card's title link remains the full-page route, so nothing depends on this. */

(function () {
  'use strict';

  var GR = window.GR;
  if (!GR) return;

  var modal = null;
  var lastTrigger = null;
  var loading = false;

  function build() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'gr-quick-modal';
    modal.id = 'gr-quick-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Quick view');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="gr-quick-modal__panel">' +
        '<button type="button" class="gr-icon-btn gr-quick-modal__close" data-gr-quick-close aria-label="Close">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="1.25" stroke-linecap="round" aria-hidden="true">' +
          '<path d="M5.5 5.5 18.5 18.5M18.5 5.5 5.5 18.5"/></svg>' +
        '</button>' +
        '<div class="gr-quick-modal__content" data-gr-quick-content></div>' +
      '</div>';

    document.body.appendChild(modal);
    return modal;
  }

  function close() {
    if (!modal || modal.hidden) return;

    modal.dataset.open = 'false';
    delete document.body.dataset.scrollLocked;

    window.setTimeout(function () {
      modal.hidden = true;
      var content = modal.querySelector('[data-gr-quick-content]');
      if (content) content.innerHTML = '';
    }, 280);

    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    document.removeEventListener('keydown', onKey);
  }

  function onKey(event) {
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab' || !modal) return;

    var items = Array.prototype.filter.call(
      modal.querySelectorAll('a[href], button:not([disabled]), select, input:not([type="hidden"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function open(handle, trigger) {
    if (loading) return;
    loading = true;
    lastTrigger = trigger;

    build();
    var content = modal.querySelector('[data-gr-quick-content]');
    content.innerHTML = '<div class="gr-quick-modal__loading" role="status">' +
      '<span class="visually-hidden">Loading</span></div>';

    modal.hidden = false;
    document.body.dataset.scrollLocked = 'true';
    window.requestAnimationFrame(function () { modal.dataset.open = 'true'; });

    modal.querySelector('[data-gr-quick-close]').focus();
    document.addEventListener('keydown', onKey);

    fetch(GR.routes.root + 'products/' + handle + '?section_id=quick-view')
      .then(function (response) {
        if (!response.ok) throw new Error('Quick view unavailable');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var inner = parsed.querySelector('[data-gr-quick-inner]');
        if (!inner) throw new Error('Quick view unavailable');

        content.innerHTML = inner.innerHTML;
        loading = false;
      })
      .catch(function () {
        loading = false;
        // Rather than show a broken panel, send the shopper to the real page.
        window.location.href = GR.routes.root + 'products/' + handle;
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-gr-quick-view]');
    if (trigger) {
      event.preventDefault();
      open(trigger.getAttribute('data-gr-quick-view'), trigger);
      return;
    }

    if (event.target.closest('[data-gr-quick-close]')) {
      close();
      return;
    }

    // Clicking the backdrop closes; clicking the panel does not.
    if (modal && !modal.hidden && event.target === modal) close();
  });

  // Once something is in the cart, the cart drawer takes over the screen.
  document.addEventListener('gr:drawer:open', function (event) {
    if (event.detail.id === 'gr-cart-drawer') close();
  });

  // Keep the select's price in step with the chosen variant.
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-gr-quick-select]');
    if (!select || !modal) return;

    var option = select.options[select.selectedIndex];
    var price = modal.querySelector('[data-gr-price-now]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  });
})();
